import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  languageList,
  languageAdd,
  languageDel,
} from "@/common/api/rest/language";

import type {
  LanguageType,
  LanguagePayloadType,
} from "@/common/types/language";

import { FormLanguage } from "@/components";

import {
  breadcrumbSimple,
  baseConfirm,
  baseModal,
  baseTable,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const tableData = ref<LanguageType[]>([]);
const payload = ref<LanguagePayloadType | null>(null);

const selected = ref<LanguageType | null>(null);

const limit = ref<number>(10);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);

const tableHeader = computed(() => [
  { key: "name", label: t("common.labels.name") },
  { key: "status", label: t("common.labels.status") },
]);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
  {
    key: "language",
    label: t("language.labels.languages"),
    url: `/register/language`,
  },
]);

const status = computed(() => ({
  ACTIVE: t("common.labels.active"),
  INACTIVE: t("common.labels.inactive"),
}));

function fetchData() {
  languageList({
    page: page.value,
    limit: limit.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changePage(value: number) {
  page.value = value;
  fetchData();
}

function changeLimit(value: number) {
  limit.value = value;
  page.value = 0;
  fetchData();
}

function searchItem(value: string) {
  search.value = value;

  fetchData();
}

function addItem() {
  showModalAdd.value = true;
}

function addItemCancel() {
  showModalAdd.value = false;
  payload.value = null;
}

function addItemConfirm() {
  if (!payload.value) return;

  store.commit("SET_LOADING", true);

  languageAdd(payload.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        editItem(data);
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function editItem(data: LanguageType) {
  // router.push(`/register/language/${data.language_id}/edit`);
  window.open(`/register/language/${data.language_id}/edit`, "_blank");
}

function removeItem(data: LanguageType) {
  selected.value = data;
  showModalDel.value = true;
}

function removeItemCancel() {
  showModalDel.value = false;
  selected.value = null;
}

function removeItemConfirm() {
  if (!selected.value) return;

  languageDel(selected.value.language_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        removeItemCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_unref(breadcrumbSimple), {
          items: breadcrumbList.value,
          "show-home": true,
          "url-home": "/home",
          active: "language"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(svgIcon), {
            icon: "no-image",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.languages")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(baseTable), {
            header: tableHeader.value,
            data: tableData.value,
            limit: limit.value,
            page: page.value,
            pages: pages.value,
            total: total.value,
            searched: searched.value,
            options: true,
            del: true,
            edit: true,
            "show-limit": true,
            "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
            "onChange:limit": _cache[1] || (_cache[1] = ($event: any) => (changeLimit($event))),
            onSearching: _cache[2] || (_cache[2] = ($event: any) => (searchItem($event))),
            "onBtn:add": _cache[3] || (_cache[3] = ($event: any) => (addItem())),
            "onBtn:edit": _cache[4] || (_cache[4] = ($event: any) => (editItem($event))),
            "onBtn:del": _cache[5] || (_cache[5] = ($event: any) => (removeItem($event)))
          }, {
            status: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(status.value[data.status]?.toUpperCase()), 1)
            ]),
            _: 1
          }, 8, ["header", "data", "limit", "page", "pages", "total", "searched"])
        ])
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('language.modals.titles.add_language').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (addItemConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormLanguage), {
          "onUpdate:data": _cache[6] || (_cache[6] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[7] || (_cache[7] = ($event: any) => (payloadValid.value = $event))
        })
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('language.modals.titles.del_language').toUpperCase(),
      message: 
      _unref(t)('language.modals.messages.del_language', {
        name: selected.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (removeItemCancel())),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (removeItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})